import { useQuery } from '@tanstack/react-query';

import { get } from '../../../lib/api';

export const useFetchBoardTier = () => {
  const {
    data: {
      canSendBroadcast,
      tier,
      nextFreeBroadcastDate,
      linkTrackingDisabled,
    },
    isFetching,
  } = useQuery(
    ['boardTier'],
    () => get('/api/client_admin/broadcasts/board_tiers'),
    {
      refetchOnWindowFocus: false,
      initialData: {
        broadcastMessages: [],
        canSendBroadcast: false,
        tier: undefined,
        nextFreeBroadcastDate: undefined,
        linkTrackingDisabled: false,
      },
    },
  );

  return {
    canSendBroadcast,
    tier,
    isFetching,
    nextFreeBroadcastDate,
    linkTrackingDisabled,
  };
};
